module.exports = __webpack_public_path__ + "static/media/MyInfoLogo.87230126.png";